import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useDispatch, useSelector } from 'react-redux';
import { addCartItemDiscount, calculateTotalPrice, removeItemFromCart } from '../../redux/features/sales.features';
import Modal from '../../components/modal/Modal';
import { Box } from '@mui/system';
import ProductDetailView from '../Product/ProductDetailView';
import ProductView from '../Product/ProductView';
import { useEffect } from 'react';



function createData(no, productId, title, weight, rate, discount, amount) { 

  return { no, productId, title, weight, rate, discount, amount };
}

// const rows = [
//   createData(1, "PRO-001", "SAPHIRe", "20c", 200000, 0, 200000),
 
// ];



const InvoiceTable = (props)=> {

  let dispatch = useDispatch();

  let salesState = useSelector((state) => {
    return state.salesReducer;
  });

  let { recentInvoice, invoice, sales , EditInvoice } = salesState;
  let { foreignInvoice, invoiceTotalAmount , invoiceItemList } = invoice;


  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [showPreciousModal, updatePreciousShowModal] = React.useState(false);
  const [selectedProduct, setSelectedProduct] = React.useState({});

  const togglePreciousModal = () => updatePreciousShowModal((state) => !state);
  const showItemDetail = (product) => {
    setSelectedProduct(product);
    togglePreciousModal();
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const columns = [
    { id: 'no', label: 'No', minWidth: 5 , align: 'left', },
    { id: 'productId', label: 'Item Code', align: 'left', minWidth: 10 },
    { id: 'title', label: 'Description', align: 'left', minWidth: 100 },
    {
      id: 'weight',
      label: 'Weight',
      minWidth: 10,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'rate',
      label: 'Rate',
      minWidth: 50,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'discount',
      label: 'Discount',
      minWidth: 50,
      align: 'right',
      format: (value) => value.toFixed(2),
    },
    {
      id: 'amount',
      label: 'Amount',
      minWidth: 50,
      align: 'right',
      format: (value) => value.toFixed(2),
    },
    {
      id: 'action',
      label: 'Actions',
      minWidth: 50,
      align: 'right',
      
    },
  ];

  const rows = (invoiceItemList || []).map((x,i)=>{
    let no =i+1
    let productId = x.productId
    let title= x.title
    let weight = (x.weight + "ct")
    let rate = props.selectedCurrency ==="LKR" ? x?.priceVariant==="true" ? x.sellPriceLocal2 : x.sellPriceLocal : x?.priceVariant==="true" ? x.sellPriceForeigners2 : x.sellPriceForeigners  //check with exchange rate + selected currency
    let discount = x.itemDiscountAmount || 0
    let amount = rate - discount
    console.log("selectedInvoice row  x?.priceVariant==='true' ", x?.priceVariant==="true" , x.productId , rate)
    return { no, productId, title, weight, rate: rate+props.selectedCurrency , discount, amount };
  })
  
  React.useEffect(()=>{},[props.selectedCurrency])

  
  const removeItem = (i, itemId) => {
    if( window.confirm("Are you sure want to delete this item from cart ? id : "+itemId)){

     
      dispatch(removeItemFromCart(i));
  
     }
     
  };

  const addItemDiscount = (index) => {
    console.log("clicked");
    let discount = prompt("Enter Discount Amount");
    if(discount){

      dispatch(
        addCartItemDiscount({
          discount,
          index,
        })
      );

    // dispatch(calculateTotalPrice());

    }
  };

  useEffect(() => {
    
  }, [invoiceItemList])
  

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', marginBottom:16 }}>
      <TableContainer sx={{ maxHeight: 'calc(100vh - 15vh)' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow className="font-extrabold text-2xl">
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, i) => {
                return (
                  <TableRow className="font-extrabold text-xl" hover role="checkbox" tabIndex={-1} key={i}>
                    {columns.map((column) => {
                      const value = row[column.id] === "no" ? i+1 : row[column.id];
                      console.log("row value rate ", value)
                      const actions = (
                        <div className="w-2/12 flex items-center">
                          <span
                            onClick={() => addItemDiscount(i)}
                            className="bg-orange-600 hover:bg-orange-700 h-full bx bx-edit p-2 text-2xl text-white"
                          ></span>
                          <span
                            onClick={() => removeItem(i, row.productId)}
                            className="bg-red-600 hover:bg-red-700 h-full bx bx-x p-2 text-2xl text-white"
                          ></span>
                          <span
                            onClick={() => showItemDetail(invoiceItemList[i])}
                            className="hover:bg-green-700  bg-green-600 h-full bx bx-show p-2 text-2xl text-white"
                          ></span>
                        </div>
                      ); 
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value || actions}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

<Modal
        modal_title={"Item Detail"}
        canShow={showPreciousModal}
        updateModalState={togglePreciousModal}
      >
        <Box>
          <ProductView  data={selectedProduct} />
        </Box>
      </Modal>
    </Paper>
  );
}

export default InvoiceTable
